import React from 'react';
import cx from 'classnames';
import { Link } from 'react-router-dom';
import Icon from 'components/Icon';
import styles from './styles.css';
import { useTranslation } from 'react-i18next';

export type Props = {
  children: any;
  className?: string;
  backTo?: string;
  backTitle?: string;
};

export const Content = ({ children, className, backTo, backTitle }: Props) => {
  const { t } = useTranslation('common');
  return (
    <div className={cx(styles.root, className)}>
      {backTo && (
        <Link to={backTo} className={styles.backButton}>
          <Icon
            name="arrow-left"
            className={styles.icon}
            width={17}
            height={17}
          />
          <span>{backTitle || t('general.back')}</span>
        </Link>
      )}
      {children}
    </div>
  );
};
